import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-text",
  "use": "icon-text-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-text\">\n<g>\n\t<path d=\"M91.862,145.362V37.989H51.753V23.623h96.494v14.366h-40.275v107.373H91.862z\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol